import Topbar from './Topbar';

interface AppLayoutProps {
  children: React.ReactNode;
}

export default function AppLayout({ children }: AppLayoutProps) {
  return (
    <div className="min-h-screen bg-[hsl(var(--background))]">
      <Topbar />
      <main className="max-w-screen-2xl mx-auto px-4 lg:px-8 xl:px-10 2xl:px-16 py-8">
        {children}
      </main>
      <footer className="border-t border-[hsl(var(--border))] mt-16 bg-white">
        <div className="max-w-screen-2xl mx-auto px-4 lg:px-8 xl:px-10 2xl:px-16 py-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <div className="flex items-center gap-2 text-sm text-[hsl(var(--foreground-muted))]">
            <span className="font-bold text-[hsl(var(--primary))]">SportsPicksBy.Design</span>
            <span>© 2026 — For entertainment purposes only</span>
          </div>
          <p className="text-xs text-[hsl(var(--muted-foreground))] text-center sm:text-right max-w-md">
            This site is intended for entertainment and personal tracking purposes only. We do not provide gambling advice, and we are not responsible for any financial losses incurred by individuals who choose to wager based on the picks displayed here. Use of this information is solely at your own risk.
          </p>
        </div>
      </footer>
    </div>
  );
}